import { Component } from '@angular/core';

import { AppConfig } from './../../app/app.config';
import { ChaseReportService, CharseReportInput,TeamCharseReportInput  } from './../../services/chasereport.service';
import { LoaddingService } from './../../providers/loadding.service';
import { NormalReportModel } from './../../models/normalreport.model';
import { StorageService } from './../../providers/storage.service';
import { PageDefault } from './../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { ModalController } from 'ionic-angular';
import { ChaseSearch } from './chasesearch';

/*
    追号记录
    TQQ 2016-12-28
*/
@Component({
    selector: "chase-report",
    templateUrl: "chasereport.html",
    providers: [ChaseReportService]
})
export class ChaseReport {
    constructor(
        private charsereport: ChaseReportService,
        private loadding: LoaddingService,
        private storage: StorageService,
        private modalCtrl: ModalController) { }

    modelList: NormalReportModel[];
    username = this.storage.read<UserModel>("User").UserName;
    isHave = true;
    paras = new CharseReportInput();
    para=new TeamCharseReportInput();
    excludeTracks = [];
    hasmore: boolean = false;
    teamFlag:boolean=false;

    ionViewDidLoad() {
        let load = this.loadding.showLoding();
        this.paras.userName=this.username;
        this.getCharseReport(this.paras).then(s => {
            this.loadding.closeLoading(load);
        });
    }


    //下拉重新加载
    //TQQ 2016-12-29
    doRefresh(refresher) {
        this.paras.pageIndex = 1;
        this.para.pageIndex = 1;
        if(!this.teamFlag){
            this.getCharseReport(this.paras).then(() => {
                refresher.complete();
            });
        }else{
             this.getTeamChaseReport(this.para).then(() => {
                refresher.complete();
            });
        }

    }

    //上拉获取下一页信息
    //TQQ 2016-12-29
    doInfinite(infiniteScroll) {
        if(!this.teamFlag){
            this.paras.pageIndex++;          
            this.getCharseReport(this.paras).then(() => {
               infiniteScroll.complete();
            });
        }else{
            this.para.pageIndex++;              
            this.getTeamChaseReport(this.para).then(() => {
                infiniteScroll.complete();
            });
        }
    }

    //查询条件
    //TQQ 2016-12-30
    presentFilter() {
        let modal = this.modalCtrl.create(ChaseSearch, this.excludeTracks);
        modal.present();
        modal.onWillDismiss((data: any[]) => {
            if (data) {
                this.excludeTracks = data;
                if(this.excludeTracks["Type"]=='1'){
                    this.teamFlag=true;
                    this.para.start = this.excludeTracks["startDate"];
                    this.para.end = this.excludeTracks["endDate"];
                    this.para.lotteryCode = this.excludeTracks["lotteryCode"];
                    this.para.userName=this.excludeTracks["subUserName"];
                    this.getTeamChaseReport(this.para);
                }else{    
                    this.teamFlag=false;                    
                    this.paras.startDate = this.excludeTracks["startDate"];
                    this.paras.endDate = this.excludeTracks["endDate"];
                    this.paras.lotteryCode = this.excludeTracks["lotteryCode"];
                    this.paras.issue = this.excludeTracks["issueNo"];
                    this.paras.state = this.excludeTracks["state"];
                    this.paras.userName=this.username;
                    this.getCharseReport(this.paras);
                }
            }
        });

    }

    //获取追号投注信息
    //TQQ 2016-12-30
    getCharseReport(input: CharseReportInput) {
        return this.charsereport.getCharseReport(this.paras).then(s => {
            if (input.pageIndex == 1) {
                this.modelList = [];
                this.modelList = s.List;
                if (s.List.length < s.PageCount) {
                    this.hasmore = true;
                } else {
                    this.hasmore = false;
                }
            } else {
                this.modelList = this.modelList.concat(s.List);
                if (this.modelList.length < s.PageCount) {
                    this.hasmore = true;
                }
                else {
                    input.pageIndex = 1;
                    this.hasmore = false;
                }
            }
            if (this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        });
    }

    //获取团队游戏记录
    //chen 2017-08-14
     getTeamChaseReport(input:TeamCharseReportInput) {
       return this.charsereport.getTeamChaseReport(input).then(s => {
            if (s.List != null) {
                if (input.pageIndex == 1) {
                    this.modelList = [];
                    this.modelList = s.List;
                    if (s.List.length < s.PageCount) {
                        this.hasmore = true;
                    } else {
                        this.hasmore = false;
                    }
                } else {
                    this.modelList = this.modelList.concat(s.List);
                    if (this.modelList.length < s.PageCount) {
                        this.hasmore = true;
                    }
                    else {
                        input.pageIndex = 1;
                        this.hasmore = false;
                    }
                }
            } else {
                this.modelList = [];
            }
            if (this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        });
    }

    //撤单的回调
    //TQQ 2017-02-23
    callback = () => {
        this.getCharseReport(this.paras);
    }
}



// WEBPACK FOOTER //
// ./src/pages/chasereport/chasereport.ts